import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import { useMutation } from '@tanstack/react-query';
import NetworkLayer from './NetworkLayer';
import SessionAPI from 'apis/SessionAPI';

const queryString = require('query-string');

const SuccessDisplay = ({location, history}) => {
  const verifyMutation = useMutation({
    mutationFn: (sessionId) => SessionAPI.verifySession(sessionId).then(r => r.data),
    retry: 3,
    retryDelay: 2000,
  });

  useEffect(() => {
    ReactGA.pageview('/welcome');

    const parsed = queryString.parse(location.search);
    const sessionId = parsed.session_id;

    if (sessionId) {
      verifyMutation.mutate(sessionId, {
        onSettled: () => history.push('/projects'),
      });
    } else {
      // Fallback: no session_id in URL (legacy behavior)
      setTimeout(() => history.push('/projects'), 50);
    }
  }, [history, location.search]);

  return (
    <NetworkLayer/>
  );
}

export default SuccessDisplay;
